/**
 * define options for Position Options, useful in PositioningMethod.fixed
 * related position towards anchor, which has eight options:
 * <br/> FixedPositionLocation.bottomLeft
 * <br/> FixedPositionLocation.topRight
 * <br/> FixedPositionLocation.topLeft
 * <br/> FixedPositionLocation.bottomRightCorner
 * <br/> FixedPositionLocation.bottomLeftCorner
 * <br/> FixedPositionLocation.topRightCorner
 * <br/> FixedPositionLocation.topLeftCorner
 * <br/> FixedPositionLocation.bottomRightCorner
 *
 */
export const FixedPositionLocation = Object.freeze({
  bottomLeft: 'bottomLeft',
  topRight: 'topRight',
  topLeft: 'topLeft',
  bottomRight: 'bottomRight',
  bottomLeftCorner: 'bottomLeftCorner',
  topRightCorner: 'topRightCorner',
  topLeftCorner: 'topLeftCorner',
  bottomRightCorner: 'bottomRightCorner',
});


/**
 * define options for PositioningMethod
 * The four possible positions realted to trigger element
 * which has two types:
 * <br/> PositioningMethod.fixed
 * <br/> PositioningMethod.fit
 *
 */
export const PositioningMethod = Object.freeze({
  fixed: 'fixed',
  fit: 'fit',
});
